//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import adminSection from '~/mixins/admin-section'
import BlogCard from '~/components/blog/blog-card.vue'
import sectionIndex from '~/components/section/index/section.vue'

export default {
  name: 'AdminSectionBlog',
  components: { sectionIndex, BlogCard },
  mixins: [adminSection],
  computed: {
    hasSectionTitle () {
      return this.getSectionTitle
    },
    getSectionTitle () {
      return this.section.title
    },
    hasSectionContent () {
      return !!this.getSectionContent
    },
    hasItems () {
      return !!this.getSectionItems
    },
    getSectionContent () {
      return this.section.content
    },
    getSectionItems () {
      return this.section.items
    },
    getSliderSettings: app => (name) => {
      const isSlider = true
      const SETTINGS = {
        'discover-flotilla': {
          isSlider: true,
          settings: {
            arrows: false,
            slidesToShow: 1,
            responsive: [
              {
                breakpoint: 576,
                settings: {
                  slidesToShow: 1,
                  arrows: false,
                  dots: true
                }
              },
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 2,
                  arrows: true,
                  dots: true
                }
              },
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  dots: false,
                  arrows: true
                }
              }
            ]
          }
        }
      }
      return {
        body: {
          isSlider,
          settings: {
            type: 'slider',
            gaps: {
              value: 24
            }
          },
          ...SETTINGS[name]
        }
      }
    }
  }
}
